import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Injectable()
export class CustomerCameraSettingsForm {
    constructor(private formBuilder: FormBuilder) {}

    public buildForm(update: boolean = false): FormGroup {
        const controlsConfig: any = {
            // modeDial: new FormControl({ value: [0], disabled: true }),
            apertureValue: [0],
            focusMode: [0],
            shootingMode: [0],
            shutterSpeed: [0],
            whiteBalanceShiftBA: [0],
            isoSpeed: [0],
            colorTemperature: [0],
            driveMode: 0,
            meteringMode: [0],
            exposure: [0],
            whiteBalance: [0],
            stillPhotoImageQuality: [[1, 14, 2]],
            aspectRatio: [0],
            autoPowerOffTime: new FormControl({ value: false }),
        };

        return this.formBuilder.group(controlsConfig);
    }
}
